module.exports = __webpack_public_path__ + "img/4.f11e65b2.png";